"use client";

import { legacyIconCls } from "@faire/web/slate/utils/tracking";
import React from "react";

import { createSVGIcon } from "./util";

/**
 * @trackcomponent
 * @optimized using svgo:^3.0.2
 */
export const GiftIcon = createSVGIcon(
  <>
    <path d="m8 4 2 2 2-2" stroke="currentColor" />
    <path stroke="currentColor" d="M5.5 6.5H14.5V15.5H5.5z" />
    <path d="M10 6.5V15M14 11H6" stroke="currentColor" />
  </>,
  "GiftIcon",
  {
    viewBox: "0 0 20 20",
    titleAccess: "GiftIcon",
    fill: "none",
    className: legacyIconCls(),
  }
);
